export { I18nProviderInjectionToken } from './lib/i18n/i18n.scope';
export { resolveTranslateAbleText } from './lib/translate-able/resolve-translate-able-text';
export {
  type TranslateAble,
  type TranslateAbleText,
  isTranslateAbleText,
} from './lib/translate-able/translate-able-text';
export {
  type I18nService,
  translateTranslateAbleText,
} from './lib/translate-able/translate-translate-able-text';
export { ResolveTranslateAbleTextPipe } from './lib/translate-able/resolve-translate-able-text.pipe';
export { type TranslateAbleResolver } from './lib/translate-able/translate-able-text.resolver';
export { i18nPrefixConcat } from './lib/i18n-prefix-concat';
export { I18nPrefixConcatPipe } from './lib/pipe/i18n-prefix-concat.pipe';
